<template>
  <lay-row>
    <lay-col md="5">
      <div style="padding: 10px;">
        <lay-quote>
          <span>统计类型：</span><br/>
          <lay-space direction="vertical" fill wrap :size="['0px', '0px']">
            <lay-button :type="activeOptions[0].theme" size="sm" fluid="true" @click="activeClick(0)">日报</lay-button>
            <lay-button style="margin-top: 10px" :type="activeOptions[1].theme" size="sm" fluid="true" @click="activeClick(1)">月报</lay-button>
            <lay-button style="margin-top: 10px" :type="activeOptions[2].theme" size="sm" fluid="true" @click="activeClick(2)">年报</lay-button>
          </lay-space>
        </lay-quote>
        <lay-quote>
          <span>统计时间选择：</span>
          <lay-date-picker v-model="date" simple type="date" allowClear v-show="(active - 1) == 0" style="width: 100%"></lay-date-picker>
          <lay-date-picker v-model="date" simple type="yearmonth" allowClear v-show="(active - 1) == 1" style="width: 100%"></lay-date-picker>
          <lay-date-picker v-model="date" simple type="year" allowClear v-show="(active - 1) == 2" style="width: 100%"></lay-date-picker>
        </lay-quote>
        <lay-quote>
          <lay-scroll height="480px" style="background-color: whitesmoke" thumbColor="#e2e2e2">
            <lay-collapse v-model="openKeys" accordion>
              <lay-collapse-item title="福州路万科中心35KV变电站" id="0" v-if="page > 0">
                <lay-space fill wrap :size="['0px', '0px']">
                  <lay-button style="margin-top: 10px" fluid="true" :type="i == activeNode ? 'primary' : ''"  size="sm" v-bind:data-id='i' v-for="(node, i) in nodeData" v-bind:key="i"   @click="nodeChange(i)">({{node.cabinet_no}}){{node.name}}</lay-button>
                </lay-space>
              </lay-collapse-item>
            </lay-collapse>

          </lay-scroll>
        </lay-quote>
      </div>
    </lay-col>
    <lay-col md="19">
      <div style="padding: 10px;">
        <v-chart class="chart" :option="option" ref="chart"></v-chart>
      </div>
    </lay-col>
  </lay-row>
</template>

<script setup>
import {reactive, ref, watch} from "vue";
import axios from "axios";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart} from "echarts/charts";
import {TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent,ToolboxComponent,MarkPointComponent} from "echarts/components";
import * as dayjs from 'dayjs';
import VChart from "vue-echarts";

use([CanvasRenderer, BarChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, ToolboxComponent, MarkPointComponent]);

const date = ref(new Date())
const nodeData = ref([])
const openKeys = reactive(['0'])
const activeOptions = reactive([{theme:"primary", type: 'date' }, {theme:"default", type: 'month' }, {theme:"default", type: 'year' }])
const active = ref(1)
const page = ref(2)
const activeNode = ref(0);
let cid = -1;
const formatDate = () => {
  return dayjs(date.value).format('YYYY-MM-DD')
}
const activeClick = (idx) => {
  active.value = idx + 1;
  for (let i = 0 ; i < activeOptions.length ; i ++){
    activeOptions[i].theme = i == idx ? 'primary' : 'default';
  }
  kwhData()
}

watch(date, () => {
  kwhData()
})

let iaData = [1]
let xData = [1]
const chart = ref()

const nodeChange = i => {
  cid = nodeData.value[i].cid;
  activeNode.value = i;
  kwhData()
}

const realtime_series_config = (name, color, data) => {
  return {
    name: name,
    type: 'bar',
    symbol: 'none',
    sampling: 'lttb',
    markPoint: {
      symbol: 'pin',
      data: [
        {type: 'min',name: '最小值'},
        {type: 'max', name: '最大值'}
      ],
    },
    itemStyle: {
      color: color
    },
    data: data
  }
}
const option = ref({
  title: {
    text: "",
    left: "left"
  },
  tooltip: {
    trigger: 'axis',
    position: function (pt) {
      return [pt[0], '10%'];
    }
  },

  xAxis: {
    type: 'category',
    data: xData
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%']
  },
  toolbox: {
    // feature: {
    //   dataZoom: {
    //     yAxisIndex: 'none'
    //   },
    //   restore: {},
    //   saveAsImage: {}
    // }
  },

  series: [
    realtime_series_config('用电量', 'rgb(13, 210, 45)', iaData),
  ]
});

const kwhData = function (){
  xData = [];
  iaData = [];
  axios.get(`/kwh?lid=5f71c506d96b4946b06b97d3128d9cb4&cid=${cid}&type=${active.value}&date=` + formatDate())
      .then(function (response) {
        if (response.data.code == 0){
          let list = response.data.data;
          xData = list.map(item => item.key);
          iaData = list.map(item => item.value);
        }
        chart.value.setOption({
          series:[
            realtime_series_config('用电量', 'rgb(13, 210, 45)', iaData),
          ],
          xAxis: {
            data: xData
          }
        })
      })
      .catch(function () {


      }).finally(() => {
        chart.value.setOption({
          series:[
            realtime_series_config('用电量', 'rgb(13, 210, 45)', iaData),
          ],
          xAxis: {
            data: xData
          }
        })
  });
}

const nodes_data = function (){
  axios.get('/nodes')
      .then(function (response) {
        if (response.data.code == 0){
          nodeData.value = response.data.data.list;
          cid = nodeData.value[0].cid;
          kwhData()
        }
      })
      .catch(function () {
      }).finally(() => {

  });
}
nodes_data()

</script>

<style scoped>
.chart{
  height: 650px;
  padding-top: 20px;
}
</style>